module.exports = __webpack_public_path__ + "static/media/404.a3454d2b.png";